import { render } from "./user_list_popover.vue?vue&type=template&id=2f138b7a"
import script from "./user_list_popover.js?vue&type=script&lang=js&external"
export * from "./user_list_popover.js?vue&type=script&lang=js&external"

import "./user_list_popover.vue?vue&type=style&index=0&id=2f138b7a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__